import { createStore, withProps, select } from '@ngneat/elf';
import { createSession, SessionModel } from '../model';
import { Env } from '../../../env';
import { filter } from 'rxjs/operators';

export interface SessionState extends SessionModel {
  loading: boolean;
}

const initialSession = createSession({ display: { currency: Env.Currency } });
const store = createStore(
  { name: 'session' },
  withProps<SessionState>({ ...initialSession, loading: false })
);

const sessionLoaded$ = store.pipe(
  select((state) => state),
  filter((state) => !!state.sessionId && !state.loading)
);

const sessionIsLoading$ = store.pipe(select((state) => state.loading));

const session$ = store.pipe(select((state) => state));

const setLoadingInSession = (loading: boolean) =>
  store.update((state) => ({ ...state, loading }));

const updateSession = (session: SessionModel) =>
  store.update((state) => ({ ...state, ...session }));

const sessionHasRooms$ = store.pipe(
  select((session) => !!session.basket.rooms.length)
);
const sessionHasRoomsSync = () => Boolean(store.getValue().basket.rooms.length);

export const SessionRepository = {
  store,
  sessionLoaded$,
  sessionIsLoading$,
  setLoadingInSession,
  updateSession,
  sessionHasRooms$,
  sessionHasRoomsSync,
  session$,
};
